import type { InjectionKey } from 'vue';

export const aiActivityStepGroupContext: InjectionKey<boolean> = Symbol(
	'aiActivityStepGroupContext',
);
